import { TransactionCategoryOptions } from '~graphql/__generated__/globalTypes';

interface PaymentItem {
  isRefundable: boolean | null | undefined;
  name: string | null | undefined;
  description: string | null | undefined;
  category: TransactionCategoryOptions | null | undefined;
}

const getPaymentName = (paymentItem: PaymentItem, t: any) => {
  if (paymentItem.category === TransactionCategoryOptions.RENTAL) {
    return `${paymentItem?.name} (${paymentItem.description})`;
  }

  if (paymentItem.isRefundable) {
    return `${
      paymentItem.name ? paymentItem.name : t('checkout_card.payment_at_booking.deposit')
    } (${paymentItem.description})`;
  }

  return paymentItem.name;
};

export default getPaymentName;
